export const getClientUsageQuery = /* GraphQL */ `query ClientUsage($clientId: ID) {
  clientUsage(clientId: $clientId) {
    clientId
    itemsCount
    quizzesCount
    aiUsageCount
  }
}`;

export const onClientUsageUpdatedSubscription = /* GraphQL */ `subscription OnClientUsageUpdated($clientId: ID) {
  onClientUsageUpdated(clientId: $clientId) {
    clientId
    itemsCount
    quizzesCount
    aiUsageCount
  }
}`;

export const manageClientUserAccessMutation = /* GraphQL */ `mutation ManageClientUserAccess($input: ManageClientUserAccessInput!) {
  manageClientUserAccess(input: $input) {
    success
    message
  }
}`;
